import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

// styled component
export const CopyButton = styled(Button)(() => ({
  padding: "2px !important",
  width: "fit-content",
  height: "14px",
  margin: "2px 2px 2px 0px !important",
  "& img": {
    width: "12px",
    height: "12px",
  },
}));

// styles for productCard
export const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: "2px",
  },
  imgDiv: {
    width: "128px",
    height: "128px",
    padding: "4px",
    minWidth: "130px",
    position: "relative",
    borderRight: "1px solid #C9C9C9",
  },
  infoDiv: {
    padding: "2px 2px 0px 8px",
    display: "flex",
    flexDirection: "column",
  },
  zoomInIcon: {
    position: "absolute",
    right: "3px",
    top: "3px",
    zIndex: 10,
    cursor: "pointer",
  },
  productImgBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    maxWidth: "100%",
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    "&:hover": {
      transform: "scale(1.02)",
      transition: "all 0.2s linear",
    },
    "& img": {
      height: "100%",
      maxWidth: "100%",
      objectFit: "contain",
    },
  },
  tooltip: {
    backgroundColor: "black",
    color: "white",
  },
  caption: {
    fontSize: "12px !important",
    fontWeight: "700 !important",
    lineHeight: "18px !important",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
  },
  manufacturer: {
    color: "#535862",
    fontSize: "12px !important",
    fontWeight: "500 !important",
    lineHeight: "18px !important",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    height: "18px",
  },
}));
